export function normalizeDocumentStatus(status?: string | null): string {
  return String(status ?? '')
    .trim()
    .toUpperCase()
    .replace(/-/g, '_');
}

export function isDraftDocumentStatus(status?: string | null): boolean {
  return normalizeDocumentStatus(status) === 'DRAFT';
}

export function isCancelledDocumentStatus(statusNorm: string): boolean {
  return statusNorm.includes('CANCEL');
}

/** E-invoice was generated then cancelled (backend may send E_INVOICE_CANCELLED or E_INVOICED_CANCELLED). */
export function isEInvoicedCancelledDocumentStatus(status?: string | null): boolean {
  const norm = normalizeDocumentStatus(status);
  return (
    norm === 'E_INVOICE_CANCELLED' ||
    norm === 'E_INVOICED_CANCELLED' ||
    (norm.includes('E_INVOICE') && norm.includes('CANCEL'))
  );
}

export function isEInvoicedDocumentStatus(status?: string | null): boolean {
  return normalizeDocumentStatus(status) === 'E_INVOICED';
}

/** Draft or failed generation may still be edited; e-invoiced / e-invoice-cancelled may not. */
export function canEditInvoiceDocument(status?: string | null): boolean {
  const norm = normalizeDocumentStatus(status);
  if (!norm || norm === 'DRAFT' || norm === 'E_INVOICE_FAILED' || norm === 'E_INVOICED_FAILED') {
    return true;
  }
  return false;
}

/** Generate e-invoice only when not already e-invoiced and not cancelled. */
export function canGenerateEInvoiceDocument(status?: string | null): boolean {
  if (isEInvoicedDocumentStatus(status) || isEInvoicedCancelledDocumentStatus(status)) {
    return false;
  }
  return true;
}

export function documentStatusBadgeClass(statusNorm: string): string {
  if (!statusNorm) return 'bg-slate-50 text-slate-600 border-slate-200';
  if (isCancelledDocumentStatus(statusNorm)) {
    return 'bg-red-50 text-red-800 border-red-200';
  }
  if (statusNorm === 'E_INVOICED') {
    return 'bg-emerald-50 text-emerald-800 border-emerald-200';
  }
  if (statusNorm === 'DRAFT') {
    return 'bg-amber-50 text-amber-900 border-amber-200';
  }
  return 'bg-slate-50 text-slate-800 border-slate-200';
}

export function documentStatusDisplayLabel(status?: string | null): string {
  const norm = normalizeDocumentStatus(status);
  if (!norm) return '—';
  if (norm === 'E_INVOICED') return 'E-Invoiced';
  if (isEInvoicedCancelledDocumentStatus(norm)) return 'E-Invoiced Cancelled';
  if (norm === 'DRAFT') return 'Draft';
  return norm.replace(/_/g, ' ');
}
